/* eslint-disable import/prefer-default-export */
import { ALL_SCOPES } from '../../constants/search/scope';

export function ensureCorrectScope(searchScope, additionalErrorStr = '') {
  if (!ALL_SCOPES.includes(searchScope)) {
    throw new Error(`Unknown scope : ${searchScope}${additionalErrorStr}`);
  }
}
